module.exports = __webpack_public_path__ + "img/48_13.6ad3a9aa.png";